import React from "react"
import { isMobileOnly } from "react-device-detect"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

import ProtectedLayout from "layouts/Protected"
import { FormSearchBike, FormAdvancedSearchBike, BikePortability } from "./Partials"
import { BikeIcon } from "components/Elements/Icons"

import { useAuth, useBikeStoreProcess } from "hooks"
import { ADMIN_GENDERS_LIST } from "utils/constants"
import { Bike } from "models"

export const HOME_SEARCH = "HOME_SEARCH"

export const SearchBikePage = () => {
	const { bikeProcessState, resetBikeStoreInfo } = useBikeStoreProcess()
	const { currentBike } = bikeProcessState

	const [bikeAvailableForPortability, setBikeAvailableForPortability] = React.useState<Bike>(null)

	React.useEffect(() => {
		// We reset all data in Bike's context before a search
		if (currentBike) {
			resetBikeStoreInfo()
		}
	}, [currentBike]) // eslint-disable-line

	const { t } = useTranslation()
	const { entity, user } = useAuth()
	const entityRole = entity?.entity_data?.entity_permission?.role

	const isMANAGEENTITIES = entityRole === "MANAGEENTITIES"
	const isAdminUser = ADMIN_GENDERS_LIST.includes(user?.gender)

	const isFormAdvancedSearchBikeDisplayed = isMANAGEENTITIES && isAdminUser

	return (
		<ProtectedLayout className="py-5">
			<div className="l-container">
				<div
					className={clsx("c-section-title mb-7", {
						"px-6": isMobileOnly,
						"px-8": !isMobileOnly,
					})}
				>
					<div className={clsx("c-section-title__content", { "flex-row": isMobileOnly })}>
						<BikeIcon size={24} />
						<h1 className={clsx("c-section-title__title c-h2 text-primary ml-4")}>
							{t(isMANAGEENTITIES ? "menu.search_bike" : "menu.activate_bike")}
						</h1>
					</div>
				</div>
				<div className={clsx({ "px-6": isMobileOnly }, { "px-8": !isMobileOnly })}>
					<div className="c-card p-5 lg:px-12 lg:py-7">
						<FormSearchBike
							isAdmin={isMANAGEENTITIES}
							context={HOME_SEARCH}
							setBikeAvailableForPortability={setBikeAvailableForPortability}
						/>
					</div>
					{bikeAvailableForPortability && (
						<BikePortability
							bikeAvailableForPortability={bikeAvailableForPortability}
						/>
					)}
					{isFormAdvancedSearchBikeDisplayed && (
						<div className="c-card p-5 lg:px-12 mt-7 lg:py-7">
							<FormAdvancedSearchBike />
						</div>
					)}
				</div>
			</div>
		</ProtectedLayout>
	)
}
